import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  Autocomplete,
  Badge,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSWRConfig } from 'swr';
import AxiosConfig from '../../../../config/AxiosConfig';
import LoadingButton from '../../utils/common/LoadingButton';
import UserAssignmentAutocomplete from '../../utils/common/UserAssignmentAutocomplete';

const DashboardSCTicketTableMenu = (props) => {
  const {
    ticket,
    shouldOpenTicketModerationDialog,
    handleOpenTicketModerationDialog,
    mutate,
  } = props;
  const services = useSelector((state) => state?.static?.services);
  const profile = useSelector((state) => state?.login?.profile);
  const ticketTypes = useSelector((state) => state?.static?.ticketTypes);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(Boolean(anchorEl));
  const [selectedUser, setSelectedUser] = useState(null);
  const [openTicketModerationDialog, setOpenTicketModerationDialog] = useState(
    Boolean(anchorEl)
  );
  const [selectedService, setSelectedService] = useState(ticket?.service);
  const [selectedTicketType, setSelectedTicketType] = useState(
    ticket?.ticketType
  );
  const [ticketIsSpam, setTicketIsSpam] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSpam, setIsLoadingSpam] = useState(false);
  const { mutate: mutateUsers } = useSWRConfig();

  useEffect(() => {
    if (shouldOpenTicketModerationDialog) {
      handleOpenModerationDialog();
    }
  }, [shouldOpenTicketModerationDialog]);

  const handleServiceChange = (e, value) => {
    if (selectedService?._id !== value?._id) {
      setSelectedService(value);
      setSelectedTicketType(null);
    }
  };

  const handleTicketTypeChange = (e, value) => {
    if (selectedTicketType?._id !== value?._id) {
      setSelectedTicketType(value);
    }
  };

  const handleTicketMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };
  const handleMessageMenuClose = () => {
    setAnchorEl(null);
    handleOpenTicketModerationDialog();
    setOpenMenu(false);
  };

  const handleOpenModerationDialog = () => {
    setOpenTicketModerationDialog(true);
    handleMessageMenuClose();
  };

  const handleTicketModerationDialogClose = () => {
    setOpenTicketModerationDialog(false);
    setSelectedUser(null);
  };

  const handleTicketModerationDialogConfirm = () => {
    setOpenTicketModerationDialog(false);
    if (ticket && ticket?._id) {
      setIsLoading(true);
      AxiosConfig.create('post', `/tickets/${ticket?._id}/changeCategorization`)
        .call({
          serviceId: selectedService?._id,
          ticketTypeId: selectedTicketType?._id,
          assignedBy: profile?._id,
          assignedTo: selectedUser ? selectedUser?._id : null,
        })
        .exit((res) => {
          mutate();
          setSelectedUser(res?.data);
          mutateUsers(`/users/`);
          setIsLoading(false);
        })
        .catch((err) => console.error(err))
        .finally(() => {
          setSelectedUser('');
        });
    }
  };

  const handleSetTicketAsSpam = () => {
    // handleMessageMenuClose();
    setTicketIsSpam(true);
  };

  const handleCancelTicketAsSpam = () => {
    setTicketIsSpam(false);
  };

  const handleConfirmTicketAsSpam = () => {
    if (ticket && ticket?._id) {
      setIsLoadingSpam(true);
      AxiosConfig.create('post', `/tickets/${ticket?._id}/setAsSpam`)
        .call()
        .exit((_res) => {
          mutate();
          setIsLoadingSpam(false);
          handleMessageMenuClose();
        })
        .catch((err) => console.error(err));
    }
  };

  return (
    <>
      <Badge
        badgeContent={' '}
        color="error"
        variant="dot"
        invisible={!ticket?.toModerate}
      >
        <MoreVertIcon
          id="ticket-button"
          // aria-controls={openMenu ? "ticket-menu" : undefined}
          // aria-haspopup="true"
          // aria-expanded={openMenu ? "true" : undefined}
          onClick={handleTicketMenuClick}
        />
      </Badge>
      <Menu
        id="ticket-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMessageMenuClose}
        slotProps={{
          list: {
            // "aria-labelledby": "message-button",
          },
        }}
      >
        <MenuItem onClick={handleOpenModerationDialog}>
          <Typography component={'span'}>
            {ticket?.toModerate ? 'Modération demandée' : 'Modérer'}
          </Typography>
        </MenuItem>
        {ticketIsSpam ? (
          <MenuItem>
            <LoadingButton
              isLoading={isLoadingSpam}
              onClick={handleConfirmTicketAsSpam}
              loadingText={false}
            >
              SPAM
            </LoadingButton>
            <Button onClick={handleCancelTicketAsSpam}>Annuler</Button>
          </MenuItem>
        ) : (
          <MenuItem onClick={handleSetTicketAsSpam}>
            <Typography component={'span'} color="red">
              SPAM
            </Typography>
          </MenuItem>
        )}
      </Menu>
      <Dialog
        open={openTicketModerationDialog}
        onClose={handleTicketModerationDialogClose}
        maxWidth={'md'}
        fullWidth
      >
        <DialogTitle>Modération du ticket</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ whiteSpace: 'pre-wrap' }}>
            {ticket?.toModerate && ticket?.moderationNote ? (
              <>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography component={'span'}>
                    {ticket?.moderationNote?.user?.firstName}{' '}
                    {ticket?.moderationNote?.user?.lastName}
                  </Typography>
                  <Typography component={'span'}>
                    {new Date(ticket?.moderationNote?.date).toLocaleString(
                      'fr-FR',
                      {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                      }
                    )}
                  </Typography>
                </Box>
                <Divider />
                <Typography component={'span'}>
                  {ticket?.moderationNote?.content}
                </Typography>
              </>
            ) : null}
          </DialogContentText>
          <Box sx={{ display: 'flex', marginTop: 2, alignItems: 'center' }}>
            {services ? (
              <>
                <Autocomplete
                  id="select-service"
                  options={services?.filter(
                    (service) =>
                      ['SCO', 'SLO', 'SAV'].indexOf(service?.code) !== -1
                  )}
                  getOptionLabel={(option) => {
                    return `${option?.code} - ${option?.name}`;
                  }}
                  isOptionEqualToValue={(option, value) => {
                    return option?._id === value?._id;
                  }}
                  filterOptions={(options, _state) => options}
                  value={selectedService}
                  onChange={handleServiceChange}
                  sx={{ width: 250 }}
                  disableClearable={true}
                  renderInput={(params) => (
                    <TextField {...params} label="Service" />
                  )}
                />
              </>
            ) : null}
            {ticketTypes ? (
              <>
                <Autocomplete
                  id="select-tickettype"
                  options={ticketTypes?.filter(
                    (ticketType) =>
                      ticketType?.service?._id === selectedService?._id
                  )}
                  getOptionLabel={(option) => {
                    return `${option?.name}`;
                  }}
                  isOptionEqualToValue={(option, value) => {
                    return option?._id === value?._id;
                  }}
                  filterOptions={(options, _state) => options}
                  value={selectedTicketType}
                  onChange={handleTicketTypeChange}
                  sx={{ width: 180 }}
                  disableClearable={true}
                  renderInput={(params) => (
                    <TextField {...params} label="Type" />
                  )}
                />
              </>
            ) : null}
            <UserAssignmentAutocomplete
              type={'ticket'}
              setSelectedUser={setSelectedUser}
              selectedUser={selectedUser}
              isSubmit={true}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleTicketModerationDialogClose}>Annuler</Button>
          <LoadingButton
            isLoading={isLoading}
            onClick={handleTicketModerationDialogConfirm}
            disabled={
              selectedTicketType === null || selectedTicketType?.name === 'MP'
            }
          >
            Confirmer
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DashboardSCTicketTableMenu;
